import { render } from "./StatusDisplay.vue?vue&type=template&id=12dd7772"
import script from "./StatusDisplay.vue?vue&type=script&lang=ts"
export * from "./StatusDisplay.vue?vue&type=script&lang=ts"
script.render = render

export default script